import { render } from "./Disclaimer.vue?vue&type=template&id=576c7bba"
import script from "./Disclaimer.vue?vue&type=script&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&lang=ts"
script.render = render

export default script